import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "smile_lime",
  "use": "smile_lime-usage",
  "viewBox": "0 0 233 105.2",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 233 105.2\" id=\"smile_lime\">\r\n<style type=\"text/css\">\r\n\t#smile_lime .st0{fill:#FFFFFF;}\r\n\t#smile_lime .st1{fill:#F5EA61;}\r\n</style>\r\n<g>\r\n\t<g id=\"smile_lime_smile_lime\">\r\n\t\t<path id=\"smile_lime_Path_250\" class=\"st0\" d=\"M202.9,5.5c-2.3-0.4-4.4,1.1-4.9,3.3c0,0.1,0,0.3-0.1,0.4c-3.9,44.1-39.3,76.1-82.1,76.1\r\n\t\t\tc-42.8,0-77.9-32-81.8-76.1c-0.2-2.3-2.2-4-4.5-3.8c-0.1,0-0.3,0-0.4,0.1l-10.9,2c-2.1,0.4-3.6,2.3-3.4,4.5\r\n\t\t\tc5.1,54,48.4,93.2,100.9,93.2c52.6,0,96.2-39.2,101.3-93.3c0.2-2.2-1.3-4.1-3.4-4.5L202.9,5.5z\" />\r\n\t\t<path id=\"smile_lime_Path_251\" class=\"st1\" d=\"M36.5,2.7c2.5,10-3.6,20.2-13.6,22.7c-10,2.5-20.2-3.6-22.7-13.6C0.1,11.5,0.1,11.2,0,11\" />\r\n\t\t<path id=\"smile_lime_Path_252\" class=\"st1\" d=\"M233,13.6c-4,9.5-14.9,14-24.5,10c-9.2-3.9-13.8-14.3-10.4-23.7\" />\r\n\t</g>\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/smile_lime.svg
// module id = vN6U
// module chunks = 0